module.exports = __webpack_public_path__ + "qrcode_wx.png?1e6f69eb4f487513bc34b5f671663ac4";